lmApp
  .controller('ShowcaseController', ['$scope', '$rootScope', 'AssetService', '$q', '$timeout', 'ShowcaseService', 'ToastService', 'ModalWindowService',
    function ($scope, $rootScope, AssetService, $q, $timeout, ShowcaseService, ToastService, ModalWindowService) {

      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {UPDATE_SHOWCASE_COLLECTION: 'update:showcase:collection'});
      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {SAVE_SHOWCASE_COLLECTION: 'save:showcase:collection'});

      $scope.showcaseData = [];
      $scope.platforms = [];
      $scope.loading = false;
      $scope.activeShowcase = {};
      $scope.activePlatform = {};
      $scope.newShowcase = {
        isShown: false,
        labels: [],
        _PrivateData: {}
      };

      var _allPredefinedLabels = [
        {
          title: 'Promo Slider',
          id: 'promo.home.slider'
        },
        {
          title: 'Background',
          id: 'promo.background.slider'
        }
      ];

      var _getLabels = function (platform) {
        var labels = [];

        switch (platform.extid) {
          case 'ottweb':
            labels = [
              {
                title: 'Promo Slider',
                id: 'promo.home.slider'
              },
              {
                title: 'Background',
                id: 'promo.background.slider'
              }
            ];
            break;
        }

        return labels;
      };

      $scope.toggleNewShowcase = function () {
        $timeout(function () {
          $scope.newShowcase.isShown = !$scope.newShowcase.isShown;
        })
      };

      $scope.createNewShowcase = function (showcase) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#showcasesLoader');

        ShowcaseService.CreateShowcase(showcase, $scope.activePlatform.id)
          .then(function (response) {
            response.showcase.labels = showcase.labels.map(function (label) {
              if (_.find(_allPredefinedLabels, {id: label})) {
                return _.find(_allPredefinedLabels, {id: label});
              } else {
                return {
                  title: label,
                  id: label
                }
              }
            });

            return ShowcaseService.SetShowcaseLabels(response.showcase)
              .then(function () {
                ToastService.Small({
                  title: 'Showcase successfully created',
                  color: 'green',
                  icon: 'view-dashboard'
                }, 1000 * 3);
                $scope.loading = false;
                $rootScope.hideLinearProgress('#showcasesLoader');
                $scope.newShowcase.isShown = false;
                $scope.newShowcase.labels = [];
                $scope.newShowcase._PrivateData = {};
                $scope.getShowcases();
              });
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
          })

      };

      $scope.showBackground = function (showcase) {
        showcase._PrivateData.background.isShown = !showcase._PrivateData.background.isShown;
      };

      $scope.saveShowcaseBackground = function (showcase, index) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#showcasesLoader');

        var allQ = {};

        if (showcase._PrivateData.background.isNew) {
          allQ.background = ShowcaseService.CreateBanner(showcase._PrivateData.background)
            .then(function (response) {
              showcase._PrivateData.background.banner_id = response.banner.id;
              showcase._PrivateData.background.isNew = false;
              return ShowcaseService.UpdateShowcase(showcase);
            });
        } else {
          allQ.background = ShowcaseService.UpdateBanner(showcase._PrivateData.background)
            .then(function (response) {
              return ShowcaseService.UpdateShowcase(showcase);
            });
        }

        $q.all(allQ)
          .then(function () {
            $rootScope.hideLinearProgress('#showcasesLoader');
            $scope.loading = false;
            ToastService.Small({
              title: 'Showcase\'s background successfully updated',
              color: 'green',
              icon: 'view-dashboard'
            }, 1000 * 3);
            $scope.getShowcases(showcase.id, index);
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Showcase\' background update failed',
              color: 'red',
              icon: 'view-dashboard'
            }, 1000 * 3);
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          })

      };

      $scope.updateShowcaseLayout = function (showcase, index) {
        var diff = showcase._Grid.filter(function (tile) {
          return tile._PrivateData.isMoved;
        });

        if (diff.length) {
          $scope.loading = true;
          $rootScope.showLinearProgress('#showcasesLoader');

          var allQ = [];

          diff.forEach(function (tile) {
            allQ.push(ShowcaseService.UpdateTilePosition(tile));
          });

          $q.all(allQ)
            .then(function (response) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
              ToastService.Small({
                title: 'Showcase layout successfully updated',
                color: 'green',
                icon: 'view-dashboard'
              }, 1000 * 3);
              $scope.getShowcases();
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
              ToastService.Small({
                title: 'Showcase layout update failed',
                color: 'red',
                icon: 'view-dashboard'
              }, 1000 * 3);
            })
        } else {
          showcase._PrivateData.isLayoutChanged = false;
        }
      };

      $scope.restoreShowcaseLayout = function (showcase, index) {
        $scope.getShowcases(showcase.id, index)
      };

      $scope.getShowcases = function (_id, index) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#showcasesLoader');

        var promise;

        if (_id) {
          promise = ShowcaseService.GetShowcasesById(_id)
            .then(function (collection) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');

              var showcase = collection[0];
              showcase._PrivateData = {};

              showcase.labels = showcase.labels.map(function (label) {
                if (_.find(_allPredefinedLabels, {id: label})) {
                  return _.find(_allPredefinedLabels, {id: label});
                } else {
                  return {
                    title: label,
                    id: label
                  }
                }
              });

              showcase.index = index;

              $scope.showcaseData[index] = showcase;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
            })
        } else {
          promise = ShowcaseService.GetShowcases()
            .then(function (collection) {
              $scope.showcaseData = _.map(collection, function (showcase, index) {
                showcase._PrivateData = {};
                showcase.index = index;
                showcase.labels = showcase.labels.map(function (label) {
                  if (_.find(_allPredefinedLabels, {id: label})) {
                    return _.find(_allPredefinedLabels, {id: label});
                  } else {
                    return {
                      title: label,
                      id: label
                    }
                  }
                });
                return showcase;
              });
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#showcasesLoader');
            })
        }

        return promise;
      };

      $scope.addNewLabel = function (showcase, label) {
        var index = _.find(showcase.labels, {id: label});

        if (!label || index) return;
        showcase.labels.push({
          title: label,
          id: label
        });
      };

      $scope.keyPress = function (showcase, keyEvent) {
        var key = keyEvent.which;

        if (key === 13) {
          $scope.addNewLabel(showcase, showcase._PrivateData.newLabel);
          showcase._PrivateData.newLabel = '';
        }
      };

      $scope.setActivePlatform = function (platform) {
        $scope.activePlatform = platform;
      };

      $scope.isActivePlatform = function (platform) {
        return platform.id === $scope.activePlatform.id;
      };

      $scope.getCurrentPlatformShowcases = function (platform) {
        return $scope.showcaseData.filter(function (showcase) {
          return showcase.platform_id === platform.id;
        });
      };

      $scope.saveShowcase = function (showcase, index) {
        if ($scope.loading) return;

        $rootScope.showLinearProgress('#showcasesLoader');
        $scope.loading = true;

        var allQ = {};

        allQ.update = ShowcaseService.UpdateShowcase(showcase);

        allQ.labels = ShowcaseService.SetShowcaseLabels(showcase);

        $q.all(allQ)
          .then(function () {
            $rootScope.hideLinearProgress('#showcasesLoader');
            $scope.loading = false;
            ToastService.Small({
              title: 'Showcase successfully updated',
              color: 'green',
              icon: 'view-dashboard'
            }, 1000 * 3);
            $scope.getShowcases(showcase.id, index);
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Showcase update failed',
              color: 'red',
              icon: 'view-dashboard'
            }, 1000 * 3);
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          })
      };

      $scope.deleteShowcase = function (showcase, index) {

        ModalWindowService.Open({
          content: '<p class="fs-headline tc-red-800"> Delete showcase </p> ' +
          '<p class="fs-title">This action will delete showcase permanently. Are You sure? </p>',
          actions: [
            {
              title: 'Delete',
              icon: 'delete',
              color: 'red',
              fn: function () {
                if ($scope.loading) return;

                $rootScope.showLinearProgress('#showcasesLoader');
                $scope.loading = true;

                ShowcaseService.DeleteShowcase(showcase)
                  .then(function () {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $scope.loading = false;
                    ToastService.Small({
                      title: 'Showcase successfully deleted',
                      color: 'green',
                      icon: 'view-dashboard'
                    }, 1000 * 3);
                    $scope.getShowcases();
                  })
                  .catch(function (reason) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'Showcase delete failed',
                      color: 'red',
                      icon: 'view-dashboard'
                    }, 1000 * 3);
                    $scope.loading = false;
                    $rootScope.debugInfo(reason);
                  })
              }
            },
            {
              title: 'Cancel'
            }
          ]
        });
      };

      function getPlatformIcon(platform) {
        var iconName;

        switch (platform.extid) {
          case 'smarttv':
            iconName = 'mdi-monitor-multiple';
            break;

          case 'android':
            iconName = 'mdi-android';
            break;

          case 'ios':
            iconName = 'mdi-apple';
            break;

          case 'stb':
            iconName = 'mdi-nest-protect';
            break;

          case 'ottweb':
            iconName = 'mdi-web';
            break;

          default :
            iconName = '';
            break;
        }

        return iconName;
      }

      $scope.getShowcases();

      $rootScope.$on($rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION, function (event, showcase) {
        $scope.getShowcases(showcase.id, showcase.index);
      });

      if (!$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION] || !$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION].length) {
        $rootScope.$on($rootScope.EVENTS.UPDATE_SHOWCASE_COLLECTION, function (event, showcase) {
          $scope.getShowcases(showcase.id, showcase.index);
        });
      }

      if (!$rootScope.$$listeners[$rootScope.EVENTS.SAVE_SHOWCASE_COLLECTION] || !$rootScope.$$listeners[$rootScope.EVENTS.SAVE_SHOWCASE_COLLECTION].length) {
        $rootScope.$on($rootScope.EVENTS.SAVE_SHOWCASE_COLLECTION, function (event, showcase) {
          $scope.saveShowcase(showcase);
        });
      }

      AssetService.GetPlatforms()
        .then(function (collection) {
          $scope.platforms = _.map(collection, function (platform) {
            platform.icon = getPlatformIcon(platform);
            platform.labels = _getLabels(platform);
            return platform;
          });
          if (collection.length) $scope.setActivePlatform($scope.platforms[0]);
        })
        .catch(function (reason) {
          $rootScope.debugInfo(reason);
        });
    }]);
